import { Injectable } from '@angular/core';
import { BaseService } from '.';
import { ProductReceipt } from '@cl/shared/models/fuel-reports/product-receipt.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class ProductReceiptsService extends BaseService<ProductReceipt> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/product-receipts/');
    }
}
